import {Popover as PopoverBase} from '@material-ui/core'

import {withStyles} from '../../theme'

export type {PopoverOrigin} from '@material-ui/core'
export const Popover = withStyles(
  theme => ({
    paper: {
      zIndex: 10000,
      ...theme.go.mixins.paper,
      fontFamily: theme.typography.fontFamily, // Лечим отсутсвие шрифта из go в других сервисах
      fontSize: theme.typography.fontSize,
    },
  }),
  {name: 'LFPopover'},
)(PopoverBase)
